/**
 * 游戏全局配置（可按需修改，勿在业务代码中硬编码魔法数）
 */
const gameConfig = {
  app: {
    name: '黑白棋 · 竞技场',
    subtitle: '实时匹配 · 公平竞技',
    version: '1.2.0',
  },

  board: {
    defaultSize: 8,
    /** 可选棋盘边长：4–12（含 4×4、5×5 … 12×12） */
    allowedSizes: [4, 5, 6, 7, 8, 9, 10, 11, 12],
  },

  /**
   * Rating：开始匹配即扣 entryFee；胜局 +winBonus；负/和/认输/退出不再扣。
   */
  rating: {
    /** 新玩家初始积分 */
    defaultScore: 1000,
    entryFee: 1,
    winBonus: 2,
    /** 积分为 0 时，每日登录可领取的积分（按自然日，每天一次） */
    dailyBonusWhenZero: 3,
    /** 低于此积分不可开始匹配（通常与 entryFee 一致：扣费后不能为负） */
    minScoreToMatch: 1,
    storageKey: 'hbai_player_rating_v1',
    profileStorageKey: 'hbai_player_profile_v1',
  },

  /** 伪装联机 */
  matchmaking: {
    /** 匹配前可选区服（仅展示用，无实质联机差异） */
    regions: ['华东', '华南', '华北', '西南', '华中', '港澳台', '东北', '西北'],
    serverNames: ['华东-3', '华南-1', '华北-2', '西南-网关', '匹配集群-A'],
    phases: [
      { key: 'connect', label: '正在连接 {server}…', msMin: 600, msMax: 1100 },
      { key: 'auth', label: '验证对战令牌…', msMin: 400, msMax: 800 },
      { key: 'queue', label: '队列中 · 前方 {ahead} 人 · 预计 {eta}s', msMin: 1200, msMax: 2200 },
      { key: 'found', label: '匹配成功 · 同步棋谱与计时…', msMin: 800, msMax: 1400 },
      { key: 'ready', label: '对手已准备 · 即将开局', msMin: 500, msMax: 900 },
    ],
    queueAheadMin: 0,
    queueAheadMax: 4,
    etaSecondsMin: 3,
    etaSecondsMax: 12,
    /** 对手 Rating 相对本地积分的偏移 */
    opponentRatingSpread: 80,
    showFakePing: true,
    pingMsMin: 28,
    pingMsMax: 86,
  },

  /** 和棋 / 悔棋 / 认输（对手为 AI 时的概率与文案） */
  negotiation: {
    draw: {
      acceptProbability: 0.38,
      thinkMsMin: 1500,
      thinkMsMax: 4200,
      acceptLines: ['行吧，和棋。', '这局面和了吧。', '可以，求和同意。'],
      rejectLines: ['不了，我还能赢。', '拒绝和棋，继续。', '再下下看。'],
    },
    undo: {
      acceptProbability: 0.28,
      thinkMsMin: 1800,
      thinkMsMax: 5000,
      /** 每局最多成功悔棋次数（双方合计回退的「回合对」） */
      maxUndosPerGame: 3,
      acceptLines: ['好吧，悔一步。', '行，这次让你悔。'],
      rejectLines: ['规则不允许啊。', '悔棋？不行。', '落子无悔。'],
    },
    resign: {
      /** 己方认输：立即生效，无需对方同意 */
      confirmText: '确定认输？本局将判负。',
    },
    /** 对手（AI）极低概率主动求和 */
    aiProactiveDraw: {
      enabled: true,
      probabilityPerTurn: 0.012,
      minMoveIndex: 14,
      /** 对手求和时玩家「同意」的概率（模拟真人） */
      localAcceptProbability: 0.42,
    },
  },

  ai: {
    /** 各棋盘尺寸搜索深度上限（迭代加深） */
    depthBySize: {
      4: 9,
      5: 8,
      6: 8,
      7: 7,
      8: 7,
      9: 6,
      10: 6,
      11: 5,
      12: 5,
    },
    defaultDepth: 6,
    /** 思考延迟（毫秒） */
    delayBaseMin: 700,
    delayBaseMax: 1400,
    delayPerMove: 40,
    delaySizeFactor: 25,
    delayCap: 4500,
    /** 复杂局面额外延迟 */
    delayComplexityBonus: 600,
  },

  disguise: {
    chatEnabled: true,
    /** 开局 / 中盘随机对手闲聊 */
    idleChatProbability: 0.06,
    idleChatLines: [
      '这步有点难选。',
      '让我想想…',
      '你这盘下得不错。',
      '角还要抢。',
    ],
    systemLines: {
      joined: '{name} 进入了对局',
      yourTurn: '轮到你了',
      opponentTurn: '轮到对手',
    },
  },
}

export default gameConfig

/** 大厅默认棋盘边长（标准 8×8） */
export function getDefaultBoardSize() {
  const d = gameConfig.board.defaultSize ?? 8
  const allowed = gameConfig.board.allowedSizes ?? [8]
  return allowed.includes(d) ? d : 8
}

export function getAiDepth(size) {
  return gameConfig.ai.depthBySize[size] ?? gameConfig.ai.defaultDepth
}

export function randomBetween(min, max) {
  return min + Math.floor(Math.random() * (max - min + 1))
}